module.exports = __webpack_public_path__ + "static/media/Accountant.d5a4895c.jpg";